<template>
  <div id="itemcontainer" class="text-center">
    <h2 class="text-center">{{Title.replace('{0}', '')}}</h2>
    <h2 class="text-center">{{Code}}</h2>
    
     <div class="row" style="margin-top: 10px">
        <div class="col-md-12 text-center">
           <img :src="Image"/>
        </div>
     </div> 
    
    <div class="row">
      <div class="col-md-12">
        <img
          v-bind:src="currentItem.photo"
          class="responsiveImage"
          style="max-height:180;max-width:180px;"
        />
      </div>
    </div>

    <br />

    <!-- Uploader de Imagenes -->
    <div class="margin-top">
      <image-uploader
        :preview="false"
        id="fileinputcode"
        :className="['fileinputcode', { 'fileinput--loaded': hasImage }]"
        capture="environment"
        :maxHeight="300"
        outputFormat="verbose"
        @input="setImage"
      >
        <label for="fileinputcode" slot="upload-label" style="cursor:pointer">
          <figure>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
              <path
                class="path1"
                d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
              />
            </svg>
          </figure>
          <span class="upload-caption">
            {{
            hasImage ? "Cambiar" : "Subir"
            }}
          </span>
        </label>
      </image-uploader>
    </div>
  </div>
</template>

<script>
import { truncate } from "fs";

export default {
  props: {
    Title: {
      type: String,
      default: "",
      description: "",
    },
    Image: {
      type: String,
      default: "",
      description: "",
    },
    MissingItemEntityID: {
      type: Number,
      default: 0,
      description: "",
    },
    Code: {
      type: String,
      default: 0,
      description: "",
    },
  },
  data() {
    return {
      ViewModel: [],
      showWelcomePanel: true,
      muestraModal: false,
      hasImage: false,
      image: null,
      resultImage: null,
      currentItem: {},
      def_photo: "img/not_photo.png",
      showResult: false,
      photo: "",
      JSONValue: "",
      Errors: [],
    };
  },
  methods: {
    emitErrors(_context) {
      this.$emit("setErrors", _context.Errors);
    },
    validate() {},
    // -- Setea la imagen
    setImage(output) {
      // -- Indica si esta cambiando la imagen (Previamente cargo una, y la cambia por otra)
      let isUpdate = this.currentItem.photo != this.currentItem.DefaultImage;

      let _context = this;
      this.image = output;
      this.currentItem.wasLoaded = true;
      var arrayName = output.info.name.split(".");
      this.currentItem.Extension = arrayName[arrayName.length - 1];
      this.hasImage = true;
      this.currentItem.photo = this.image.dataUrl;
      this.currentItem.photoClear = this.currentItem.photo.replace(
        "data:" + this.image.type + ";base64,",
        ""
      );

      this.JSONValue = JSON.stringify({
        Extension: this.currentItem.Extension,
        Base64: this.currentItem.photoClear,
      });
      _context.emitErrors(_context);

      this.$emit("saveValue", {
        MissingItemEntityID: this.MissingItemEntityID,
        JSON: this.JSONValue,
      });

      if (isUpdate) this.$forceUpdate();
    },
  },
};
</script>